<mulan-button 
    [ngClass]="{'safari': factorySer.isSafari}"
    [fill]="fill" 
    theme="primary" 
    debounceClick 
    [disabled]="disabled" 
    [toastControl]="toastControl"
    [debounceTime]="debounceTime" 
    (debounceClick)="btnAction()">
    {{format? (label | acpText) : label}} 
</mulan-button>